import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { BorderWrapper } from 'components/styled-components';
import { H3 } from '@blueprintjs/core';
import { fetchAuditLog } from 'actions/utils';
import Pagination from 'components/pagination';
import styled from 'styled-components';
import colors from 'utils/colors';
import map from 'lodash/map';
import moment from 'moment';

const LogRow = ({ auditLog }) => {
  const name = `${auditLog.firstName} ${auditLog.lastName}`;
  const initials = `${auditLog.firstName.charAt(0)}${auditLog.lastName.charAt(0)}`;
 // const zzz = "<p><br /><b>Tiffs 2nd question - Jay:</b><br />Tiffs answer<br /><br /><b>Mary's Test Pre Screen Question:</b><br />Mary's Answer #1<br /><br /><b>Type of Data:</b><br />PCI, PHI, PII<br /><br /><b>Type of Access:</b><br />VPN<br /><br /><b>Type of Product/Service:</b><br />Registry/Study<br /><br /><b>Importance of Operations:</b><br />Operations Cannot Continue<br /><br /><b>Jay's Qool Question - Edit:</b><br />One<br /><br /><b>Change Reason:</b><br />The answers were wrong!</p>";
  return (
    <LogWrapper>
      <div style={{ width: '100%' }}>
        <LogInfo>
          <UserIcon>
            <span>{initials}</span>
          </UserIcon>
          {name}
          <span
            style={{
              fontSize: '0.75rem',
              fontWeight: '700',
              marginLeft: '0.5rem',
            }}
          >
            {auditLog.date}
          </span>
        </LogInfo>
        <LogContent>
			{auditLog.modifyMessage}
			{typeof auditLog.modifiedData === 'undefined' || auditLog.modifiedData === "" || auditLog.modifiedData === null ? "" :
				<span dangerouslySetInnerHTML={{__html: auditLog.modifiedData}} />
			}
		</LogContent>
      </div>
    </LogWrapper>
  );
};

const AuditLogBase = ({
	auditLog,
  vendorRequestID,
  fetchAuditLog,
}) => {
  const PER_PAGE = 10;
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
	fetchAuditLog({ start: currentPage * PER_PAGE, limit: PER_PAGE, vendorRequestID });
  }, [currentPage]);

  const handlePageClick = page => {
    setCurrentPage(page);
  };

  return (
    <BorderWrapper margin="1rem" padding="1rem">
      <H3>Audit Log</H3>
      {map(auditLog.logs, (log, i) => (
        <LogRow auditLog={log} key={i} />
      ))}
      {auditLog.totalCount > PER_PAGE && (
        <Pagination
          numRecords={auditLog.totalCount}
          perPage={PER_PAGE}
          currentPage={currentPage}
          onPageClick={handlePageClick}
          handlePerPageChange={null}
          hidePerPage={true}
        />
      )}
    </BorderWrapper>
  );
};

const LogWrapper = styled.div`
  display: flex;
  padding: 0.5rem;
  margin: 0.5rem;
`;

const LogInfo = styled.div`
  width: 90%;
  display: flex;
  align-content: baseline;
  align-items: baseline;
`;

const UserIcon = styled.div`
  border-radius: 50px;
  background: ${colors.brandingPrimary};
  text-transform: uppercase;
  font-size: 1rem;
  height: 2.2rem;
  width: 2.2rem;
  margin: 0 1rem;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LogContent = styled.div`
  margin-left: 4.5rem;
  color: ${colors.gray};
`;

const mapStateToProps = state => ({
	auditLog: state.utils.auditLog,
	isFetching: state.utils.isFetchingAuditLog,
});

const AuditLog = connect(
  mapStateToProps,
  { fetchAuditLog }
)(AuditLogBase);

export default AuditLog;
